// Engine scores remain 0–10; only presentation is rescaled.
export const score100 = (value, digits = 2) => value == null ? "N/A" : (Number(value) * 10).toFixed(digits);
